export const NETWORK_ACTIVE_TAB_LEVEL_KEY = "network_active_tab_level";
export const NETWORK_RESTORE_ONCE_KEY = "network_restore_once";

export const NETWORK_FILTER_KEYS = [
  "network_filters_nec",
  "network_filters_sec",
  "network_filters_rec",
  "network_filters_dec",
];

export const setNetworkRestoreOnce = () => {
  sessionStorage.setItem(NETWORK_RESTORE_ONCE_KEY, "1");
};
